import { InjectionToken } from '@angular/core';

export const ENV_CONFIG = new InjectionToken<env.EnvConfigurationData>('env.json');
export const VER_CONFIG = new InjectionToken<ver.VerData>('ver.json');
